import React from 'react';
import PropTypes from 'prop-types';

/**
 * ConditionalWrapper - Conditionally wraps children with any wrapper component
 * @param {boolean} condition - Whether to wrap the children
 * @param {React.Component} wrapper - The component to wrap with (e.g., Dialog, Paper, div, etc.)
 * @param {object} wrapperProps - Props to pass to the wrapper component
 * @param {React.ReactNode} children - Content to wrap
 */
const ConditionalWrapper = ({
  condition,
  wrapper: Wrapper,
  wrapperProps = {},
  children
}) => {
  if (condition && Wrapper) {
    return <Wrapper {...wrapperProps}>{children}</Wrapper>;
  }

  return children;
};

ConditionalWrapper.propTypes = {
  condition: PropTypes.bool.isRequired,
  wrapper: PropTypes.elementType,
  wrapperProps: PropTypes.object,
  children: PropTypes.node.isRequired
};

ConditionalWrapper.defaultProps = {
  wrapper: null,
  wrapperProps: {}
};

export default ConditionalWrapper;
